import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DetalleServiceService {
  
  dataPTW:any

  constructor() { }
}
